<template>
  <!-- Modal -->
  <div class="modal fade" id="ArchiveStockClosingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('inventory.closing_process')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <select v-model="selectedMonth" class="custom-select">
            <option selected value="">-</option>
            <option v-for="(month, i) in closingMonths" :value='month.key' :key="i">{{month.value}}</option>
          </select>
        </div>
        <div class="modal-footer">
          <button ref="closeMonthModal" type="button" class="btn btn-secondary" data-dismiss="modal" @click="selectedMonth=''">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="selectClosingMonth()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveStockClosingModal',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      closingMonths: [],
      selectedMonth: '',
      isSearching: false
    }
  },
  created () {
    this.getClosingMonths()
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getClosingMonths () {
      try {
        let months = await this.$http.post(this.$api_url.inventory_unclosed_dates)
        let $data = this.$invoiceTools.prepareResult(months.data, 'months', 'ArchiveStockClosingModal:getUnclosedMonths')
        if ($data.success === true) {
          this.closingMonths = months.data.dates
        } else {
          this.closingMonths = []
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('ArchiveStockClosingModal:getUnclosedMonths:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    selectClosingMonth () {
      if (this.selectedMonth === '') {
        this.$toastr.warning(this.translations('inventory.message_notification_enter_closing_date'))
        return
      }

      this.isSearching = true

      this.addParams = {
        closing_date: this.selectedMonth
      }

      console.log('ArchiveStock:' + this.$api_url.inventory_closing + ':params -- ', JSON.stringify(this.addParams))

      try {
        this.$http.post(this.$api_url.inventory_closing, this.addParams).then(result => {
          console.log('ArchiveStock:' + this.$api_url.inventory_closing + ':response -- ', JSON.stringify(result))

          if (result.data && result.data.status === true) {
            this.$toastr.success('在庫締め処理を完了しました', 'Success')
            this.$refs.closeMonthModal.click()
            this.selectedMonth = ''

            this.getClosingMonths() // REFRESH
          } else {
            this.$toastr.error(result.data.message, 'エラー')
          }
          this.isSearching = false
        })
      } catch (error) {
        console.log('error: ', JSON.stringify(error))
        this.$toastr.error('エラーが発生しました。ご確認後再試行してください。', 'エラー')
        this.isSearching = false
      }
    },

    // テストデータ
    loadClosingMonths () {
      return [{
        key: '201901',
        value: '2019年1月'
      },
      {
        key: '201902',
        value: '2019年2月'
      },
      {
        key: '201903',
        value: '2019年3月'
      },
      {
        key: '201904',
        value: '2019年4月'
      },
      {
        key: '201905',
        value: '2019年5月'
      },
      {
        key: '201906',
        value: '2019年6月'
      }]
    }

  }
}
</script>
